var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.257 8.61617L16.157 14.5162C16.4693 14.8266 16.8917 15.0008 17.332 15.0008C17.7723 15.0008 18.1947 14.8266 18.507 14.5162C18.6632 14.3612 18.7872 14.1769 18.8718 13.9738C18.9564 13.7707 19 13.5529 19 13.3328C19 13.1128 18.9564 12.895 18.8718 12.6919C18.7872 12.4888 18.6632 12.3044 18.507 12.1495L11.4403 5.08284C11.2854 4.92663 11.1011 4.80264 10.898 4.71802C10.6949 4.63341 10.477 4.58984 10.257 4.58984C10.037 4.58984 9.81914 4.63341 9.61604 4.71802C9.41294 4.80264 9.22861 4.92663 9.07367 5.08284L1.92367 12.1495C1.7692 12.3052 1.64699 12.4899 1.56405 12.693C1.48111 12.8961 1.43907 13.1135 1.44033 13.3328C1.43907 13.5522 1.48111 13.7696 1.56405 13.9727C1.64699 14.1757 1.7692 14.3604 1.92367 14.5162C2.23594 14.8266 2.65836 15.0008 3.09867 15.0008C3.53898 15.0008 3.9614 14.8266 4.27367 14.5162L10.257 8.61617Z",
    fill: "#262836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2ff86be3136a8e79f177288d4187bd14.svg";
export { ForwardRef as ReactComponent };